export default __webpack_public_path__ + "static/media/logo_sindjus.f2f53975.svg";